import React,{useState,useEffect} from "react";
import { Button, message } from "antd";
import { showConfirm } from './../custom-components/custom-component';
import { handleBlockAllSeats } from './block-all-seats.module';
import { isValid, isValidArray,checkActionAllowed } from "../../utils/utilities";
import { ACTION_BLOCK_ALL_TICKETS_ALLOWED, isSharedTripCheck } from './../../utils/constant';
import { fetchSharingActionsForOperator } from './../common-components/search-result-item-card/search-result-item-card.module';
import './block-all-seats.styles.scss';

export const BlockAllSeatsComponent = (props) => {

    const{
        selectedSchedule,
        fetchSeats
    }=props;

    // Shared trip: follow the sharing agent's permissions
    const isSharedTrip = isValid(selectedSchedule)&&isSharedTripCheck(selectedSchedule.operator_code);
    const [sharingActions,setSharingActions] = useState(null);

    useEffect(()=>{
        if(isSharedTrip){
            fetchSharingActionsForOperator(selectedSchedule.operator_code,(actions)=>{
                setSharingActions(actions);
            });
        }
    },[isValid(selectedSchedule)?selectedSchedule.operator_code:null]);

    const checkSeatActionAllowed=(actionName)=>{
        if(isSharedTrip){
            return isValid(sharingActions)&&isValid(sharingActions[actionName]);
        }
        return checkActionAllowed(actionName);
    }

    const onSuccess=()=>{
        fetchSeats(selectedSchedule.trip_route_id);
    }

    const onFailure=()=>{
        message.error("Failed to block trips!")
    }

    const handleClick=()=>{
        showConfirm(()=>{
            if(isValidArray(selectedSchedule)&&isValidArray(selectedSchedule.trip)&&isValid(selectedSchedule.trip.id)){
                let tripId=selectedSchedule.trip.id;
                handleBlockAllSeats(tripId,selectedSchedule.trip_route_id,onSuccess,onFailure);
            }else{
                message.error("Trip not selected!")
            }
        },"Block all seats","Are you sure to block all available seats");
    }
    if(checkSeatActionAllowed(ACTION_BLOCK_ALL_TICKETS_ALLOWED)){
        return (
            <div className="marginTop marginBottom">
                <Button onClick={handleClick} className="block-all-available-btn">
                    Block all available seats
                </Button>
            </div>
        )
    }else{
        return null
    }
}
